"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ObjectAssociationTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectAssociationTypes"));

var _default = function _default(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId,
      associations = _ref.associations;
  var engagementAssociations = (0, _immutable.fromJS)({
    ownerIds: [],
    contactIds: [],
    companyIds: [],
    dealIds: [],
    ticketIds: []
  }).update(_ObjectAssociationTypes.default[objectType], function (associationsList) {
    return associationsList.push(Number(subjectId));
  });
  return associations.reduce(function (associationsMap, associationsForType, curObjectType) {
    var idList = associationsForType.keySeq().toList();
    return associationsMap.update(_ObjectAssociationTypes.default[curObjectType], function (associationsList) {
      return associationsList.concat(idList);
    });
  }, engagementAssociations);
};

exports.default = _default;
module.exports = exports.default;